// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"e6356f8784ffa8a7","5285":"96429d37121c0156"}[chunkId] + ".css";
};